<script lang="ts">
	import '../app.css';
	import Navbar from '$lib/components/navbar/Navbar.svelte';
	import SubstackLink from '$lib/components/SubstackLink.svelte';
	import { page } from '$app/stores';
	import { SiFacebook, SiGithub, SiGitlab, SiX } from '@icons-pack/svelte-simple-icons';
</script>

<svelte:head>
	<script src="https://challenges.cloudflare.com/turnstile/v0/api.js" async defer></script>
	<link rel="canonical" href="https://dsarc.us{$page.url.pathname}" />
	<link rel="alternate" type="application/rss+xml" title="DSARC — All Updates" href="/rss.xml" />
	<link rel="alternate" type="application/rss+xml" title="DSARC Events" href="/rss/events.xml" />
	<link
		rel="alternate"
		type="application/rss+xml"
		title="DSARC Meeting Minutes"
		href="/rss/meetings.xml"
	/>
</svelte:head>

<div class="min-h-screen bg-white dark:bg-gray-900 dark:text-white">
	<Navbar />

	<main class="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8" data-pagefind-body>
		<slot />
	</main>

	<footer class="mt-auto bg-gray-800 py-12 text-white">
		<div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
			<div class="grid grid-cols-1 gap-8 md:grid-cols-3">
				<div>
					<h3 class="mb-4 text-lg font-semibold">Contact Us</h3>
					<p>
						Weekly Net:
						<br />
						Tuesdays at 1830 on the WA7HWD Repeater, 146.820 MHz -0.600 MHz 127.3Hz
					</p>
					<p class="mt-4">
						Club Meetings: First and Third Tuesday of every month at 6:30 PM (with holiday
						exceptions)
					</p>
				</div>
				<div>
					<h3 class="mb-4 text-lg font-semibold">Quick Links</h3>
					<ul class="space-y-2">
						<li><a href="/membership" class="hover:text-blue-300">Join DSARC</a></li>
						<li><a href="/calendar" class="hover:text-blue-300">Calendar</a></li>
						<li>
							<a href="/resources/repeaters" class="hover:text-blue-300">Repeater Directory</a>
						</li>
						<li><a href="/contact" class="hover:text-blue-300">Contact</a></li>
						<li><a href="/feeds" class="hover:text-blue-300">Subscribe</a></li>
					</ul>
				</div>
				<div>
					<h3 class="mb-4 text-lg font-semibold">Follow Us</h3>
					<div class="flex space-x-4">
						<a
							href="https://www.facebook.com/dosomethingarc"
							target="_blank"
							rel="noopener noreferrer"
							class="hover:text-blue-300"
						>
							<span class="sr-only">Facebook</span>
							<SiFacebook class="h-8 w-8" />
						</a>
						<a
							href="https://x.com/DoSomethingARC"
							target="_blank"
							rel="noopener noreferrer"
							class="hover:text-blue-300"
						>
							<span class="sr-only">Twitter</span>
							<SiX class="h-8 w-8" />
						</a>
					</div>
					<div class="mt-4 flex space-x-4">
						<a
							href="https://gitlab.com/dsarc"
							target="_blank"
							rel="noopener noreferrer"
							class="hover:text-blue-300"
						>
							<span class="sr-only">GitLab</span>
							<SiGitlab class="h-8 w-8" />
						</a>
						<a
							href="https://github.com/Do-Something-ARC"
							target="_blank"
							rel="noopener noreferrer"
							class="hover:text-blue-300"
						>
							<span class="sr-only">GitHub</span>
							<SiGithub class="h-8 w-8" />
						</a>
					</div>
					<div class="mt-4">
						<SubstackLink compact={true} />
					</div>
				</div>
			</div>

			<div class="mt-8 border-t border-blue-700 pt-8 text-center">
				<p>&copy; 2026 Do Something Amateur Radio Club. All rights reserved.</p>
			</div>
		</div>
	</footer>
</div>
